/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2014, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define({
	'dlg_loading': 'Bezig met laden...',
	'dlg_close': 'Sluiten',
	'dlg_ok': 'OK',
	'dlg_cancel': 'Annuleren',
	'dlg_back': 'Teruggaan',
	'dlg_done': 'Gereed',
	'dlg_save': 'Opslaan',

	// Slider
	'sliderRegionLabel': 'Schuifregelaar - met de rechter en linker cursortoetsen verplaatst u de handvatten van de schuifregelaar',
	'sliderHandleLabel': 'Handvat van schuifregelaar',
	'a11ySliderHandleLabel': 'Hendel schuifregelaar %{sliderValue}',
	'sliderInputLabel': 'waarde',

	// Side bar
	'sidebarAdd': 'Toevoegen',
	'clearTextFilterValue': 'Verwijderen',
	'missingDataSetData': 'De gegevens voor deze gegevensset zijn niet beschikbaar. Vernieuw de gegevensset of vraag de beheerder om toegang tot de bron.',

	// Toolbar
	'toolbarRegionLabel': 'Werkbalk',
	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',
	//TextToolbar
	'fontSelect': 'Letterfamilie',
	'fontFamilyStyle': 'Letterstijl',
	'regularFontStyle': 'Regulier',
	'fontSizeSelect': 'Lettergrootte',
	'fontColorSelect': 'Kleur',
	'fontStyle': 'Stijl',
	'colorPickerTitle': 'Een kleur selecteren',
	'bold': 'Vet',
	'italic': 'Cursief',
	'underline': 'Onderstrepen',
	'fontAlignment': 'Uitlijning',
	'justifyLeft': 'Links uitlijnen',
	'justifyCenter': 'Centreren',
	'justifyRight': 'Rechts uitlijnen',
	'insertOrderedList': 'Geordende lijst',
	'insertUnorderedList': 'Niet-geordende lijst',
	'fontColorPicker': 'Kleurenselector',
	'textWrap': 'Tekst laten doorlopen',
	'restore': 'Standaardwaarden herstellen',
	'textAutoFontSize': 'Automatisch',
	'textDefaultFontSize': 'Standaard',
	'textItemTitle': 'Titel',
	'textLabelShadow': 'Schaduw label',
	'textContrastLabelColor':'Contrastkleur',
	'toggleOn': 'Aan',
	'toggleOff': 'Uit',
	'contrastLabelColorInfo': 'Automatisch aanpassen van labelkleur voor toegankelijkheid. Dit overschrijft de kleur van het lettertype.',
	'labelShadowInfo':'Voeg schaduw toe aan tekst voor toegankelijkheid.',
	'applyToAll':'Stijl toepassen op alle assen',

	// Top Bottom
	'topbottomNumberOfResultsLabel': 'Aantal resultaten (%{lower} - %{higher})',
	'topbottomPercentLabel': 'Percentage (%{lower}% - %{higher}%)',
	'topbottomSelectOption': 'Optie voor hoogste of laagste',
	'topbottomOptionLabel': 'Weergeven',
	'searchByLabel': 'Op',
	'searchNoMatches': 'Geen overeenkomsten gevonden',
	'topbottomRankColumnLabel': 'Een kolom voor rangorde toevoegen aan de tabel',
	'topbottomNone': 'Geen',
	'topCount': 'Hoogste aantal',
	'topPercent': 'Bovenste %',
	'bottomCount': 'Laagste aantal',
	'bottomPercent': 'Onderste %',
	'searchColumn': 'Een kolom zoeken',
	'searchColumnAriaLabel': 'Een kolom zoeken. Typ de naam van de kolom om te zoeken en gebruik vervolgens de pijl omlaag om de kolom in een lijst op te zoeken',
	'searchColumnQualifiedLabel': '%{columnLabel} (%{columnId})',
	'rankColumnLabel': 'Rang (%{columnLabel})',
	'topbottomClearLabel': 'Opnieuw instellen',

	// Format
	'formatAuto': 'Automatisch',
	'formatConvertPercent': 'Decimaal converteren naar percentage',
	'formatAbbreviate': 'Afkorten',
	'formatUseGrouping': 'Scheidingsteken voor duizendtallen gebruiken',
	'dateStyle': 'Datumstijl',
	'dateTimeStyle': 'Datum/tijd-stijl',
	'formatMissingValueCharactersInfo': 'Tekens voor ontbrekende waarden geven de tekens aan die moeten worden afgebeeld wanneer de waarde ontbreekt.',
	'currencySymbolLabel': 'Valutateken',
	'customSymbolPlaceholder': 'Een symbool toevoegen',
	'customSymbolLabelInfo': 'Hiermee geeft u een teken of de tekens op die u wilt gebruiken als aangepast symbool. Dit symbool staat vóór het getal en een eventueel teken.',
	'numberLabel': 'Label van nummer',
	'numberPositionLabel': 'Labelpositie',
	'negativeSignPosition': 'Positie negatief minteken',
	'negativeSign': 'Mintekensymbool',
	'numberLabelInfo': 'Hiermee geeft u een label op voor het opgemaakte getal; dit wordt als prefix of suffix geplaatst, afhankelijk van de positie van het label.',
	'nullValueDefault': '<standaard>',
	'nullValueContent': '(geen waarde)',
	'default': 'Standaardwaarde',
	'beginning': 'Begin',
	'end': 'Eind',
	'formatLabel': 'Selecteer een indeling',

	// More data indicator
	'moreDataIndicator': 'Uw gegevens zijn afgekapt bij %{threshold} items. Pas een filter toe om minder af te beelden.',

	// Expanded View / Focus mode
	'evCollapse': 'Samenvouwen',
	'duplicate': 'Dupliceren',
	'copyOf': 'Kopie van %{name}',
	'unableToDuplicateBoard': '"%{name}" kan niet gedupliceerd worden.',

	// Widget list
	'errorLoadingWidgetList': 'We kunnen de objecten niet laden',

	// Custom widgets
	'customWidget': 'Aangepaste widget',

	// Auto group
	'group': 'Groeperen',

	// TODO: Carbon design removes Font Family subClass, no longer needed when FF 'PropertiesV2' is enabled
	// START: Remove FontFamilySubClass
	'textFontFamilySubClassHairline': 'Haarlijn',
	'textFontFamilySubClassThin': 'Dun',
	'textFontFamilySubClassThinItalic': 'Dun cursief',
	'textFontFamilySubClassExtraLight': 'Extra licht',
	'textFontFamilySubClassExtraLightItalic': 'Extra licht cursief',
	'textFontFamilySubClassLight': 'Licht',
	'textFontFamilySubClassLightItalic': 'Licht cursief',
	'textFontFamilySubClassRegular': 'Regulier',
	'textFontFamilySubClassRegularItalic': 'Normaal cursief',
	'textFontFamilySubClassItalic': 'Cursief',
	'textFontFamilySubClassMedium': 'Gemiddeld',
	'textFontFamilySubClassMediumItalic': 'Medium cursief',
	'textFontFamilySubClassHeavy': 'Zwaar',
	'textFontFamilySubClassHeavyItalic': 'Zwaar cursief',
	'textFontFamilySubClassDemiBold': 'Half vet',
	'textFontFamilySubClassDemiBoldItalic': 'Half vet cursief',
	'textFontFamilySubClassBold': 'Vet',
	'textFontFamilySubClassBoldItalic': 'Vet cursief',
	'textFontFamilySubClassExtraBold': 'Extra vet',
	'textFontFamilySubClassExtraBoldItalic': 'Extra vet cursief',
	'textFontFamilySubClassBlack': 'Zwart',
	'textFontFamilySubClassBlackItalic': 'Zwart cursief',
	'textFontFamilySubClassStencil': 'Stencil',
	// END: Remove FontFamilySubClass
});
